import { cn } from '@/lib/utils'
import { useState } from 'react'
import { ChevronDownIcon, ExternalLinkIcon, InfoIcon } from '@/components/icons'

const InlineInfo = ({ text }: { text: string }) => {
    const [isExpanded, setIsExpanded] = useState(false)

    return (
        <div className="tw:px-2 tw:py-3 tw:bg-gray-500 tw:rounded-lg">
            <div className="tw:flex tw:flex-row tw:gap-1">
                <InfoIcon className="tw:text-gray-200 tw:!min-w-4 tw:!min-h-4 tw:w-4 tw:w-4" />
                <div>
                    <span className="tw:leading-[21px] tw:text-sm">{text}</span>
                    <div
                        className="tw:flex tw:mt-1 tw:items-center tw:gap-1 tw:text-blue-300 tw:cursor-pointer"
                        onClick={() => setIsExpanded(!isExpanded)}
                    >
                        <ChevronDownIcon
                            strokeWidth="3"
                            className={cn('tw:w-4 tw:h-4 tw:transition-transform', {
                                'tw:-rotate-90': !isExpanded,
                                'tw:rotate-0': isExpanded,
                            })}
                        />
                        <span className="tw:text-sm tw:font-bold">Learn more</span>
                    </div>
                    <div
                        className={cn(
                            'tw:grid tw:transition-all tw:duration-300 tw:ease-in-out',
                            isExpanded
                                ? 'tw:grid-rows-[1fr] tw:opacity-100 tw:mt-2'
                                : 'tw:grid-rows-[0fr] tw:opacity-0 tw:mt-0',
                        )}
                    >
                        <div className="tw:overflow-hidden">
                            <div className="tw:flex tw:flex-col tw:gap-1 tw:ml-5">
                                <a
                                    href="https://www.facebook.com/business/ads/ad-objectives"
                                    target="_blank"
                                    className="tw:flex tw:text-sm tw:!text-blue-300 tw:underline hover:tw:text-blue-200 tw:leading-[21px] tw:font-semibold gap-1"
                                >
                                    <ExternalLinkIcon /> Ad objectives
                                </a>
                                <a
                                    href="https://www.facebook.com/business/ads/ad-objectives/awareness"
                                    target="_blank"
                                    className="tw:flex tw:text-sm tw:!text-blue-300 tw:underline tw:leading-[21px] tw:font-semibold gap-1"
                                >
                                    <ExternalLinkIcon className="tw:h-6 tw:w-6 tw:min-h-6 tw:min-w-6" /> Expand your
                                    reach and maintain a strong presence with customers using the awareness objective.
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InlineInfo
